export const TWO_AUTH_RESPONSE_CODES: ReadonlyArray<string> = [
    "OTPSmsRequired",
    "OTPEmailRequired",
    "TOTPRequired",
];

export const SESSION_ERROR_RESPONSE_CODES: ReadonlyArray<string> = [
    "NoCookieError",
    "RemoveCookieError",
    "PasswordExpired",
    "PasswordChangeRequired",
    "PasswordChangeFailed",
    "UserMustChangePassword",
    "PasswordChangeMismatchedPolicy",
    "PasswordChangeWrongOldPassword",
    "AccountExpired",
    "AccountLocked",
    "AccountBlocked",
    "AccountNotActivated",
    "AccessDenied",
    "UserNotFound",
    "EmptyUserName",
    "InvalidDomain",
    "InvalidUserName",
    "TooManyUsersLoggedIn",
    "UserLoggedInTooManyTimes",
    ...TWO_AUTH_RESPONSE_CODES,
    "OnlyOneAppPerBrowser",
    "LogonLimitExceeded",
    "Invalid2FAKey",
    "KeyExpired",
    "KeyLimitExceeded",
    "DBError",
    "InvalidToken",
    "Unknown",
    "ERROR",
    "NULL",
];

export const SESSION_RESET_RESPONSE_CODE = "SESSION_RESET";
